// extracted by mini-css-extract-plugin
module.exports = {"items":"AccordionMenuItem_items__V9ntn","item":"AccordionMenuItem_item__iXf0W"};